import { toast } from "react-toastify";
import { GetAllUOMApi } from "../../../Api/Store/Uom";

export const GetAllUOM = (data) => {
  return {
    type: "get_all_uom",
    payload: data,
    loader: false,
  };
};

export function getallUOM() {
  return async (dispatch) => {
    try {
      const result = await GetAllUOMApi();

      if (result.data?.IsSuccess === true) {
        dispatch(GetAllUOM(result.data.Data));
      } else {
        toast.error(result.data?.Message || "Failed to fetch UOMs");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching UOMs!");
    }
  };
}
